import React from 'react'

const CompetitionIcon = (props: any = {}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" {...props} width={props.size ?? 28} height={props.size ?? 28} viewBox="0 0 20 20" fill="none">
            <path d="M15 6.66797C15 9.42939 12.7614 11.668 10 11.668C7.23858 11.668 5 9.42939 5 6.66797C5 3.90654 7.23858 1.66797 10 1.66797C12.7614 1.66797 15 3.90654 15 6.66797Z" stroke="#8C92A2" strokeWidth="1.25" />
            <path d="M5.41797 8.49219C3.26143 9.04724 1.66797 11.0049 1.66797 13.3347C1.66797 16.0961 3.90654 18.3347 6.66797 18.3347C9.42939 18.3347 11.668 16.0961 11.668 13.3347C11.668 12.7058 11.5519 12.104 11.3399 11.5496" stroke="#8C92A2" strokeWidth="1.25" />
            <path d="M10 17.0615C10.8846 17.8532 12.0527 18.3347 13.3333 18.3347C16.0948 18.3347 18.3333 16.0961 18.3333 13.3347C18.3333 11.0049 16.7399 9.04724 14.5833 8.49219" stroke="#8C92A2" strokeWidth="1.25" />
        </svg>
    )
}

export default CompetitionIcon